import React, { memo, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selDepartments } from "app/routes/dashboard/routes/generalSettings/slice/generalSettingSlice";
import { getDepartment } from "app/routes/dashboard/routes/generalSettings/slice/generalSettingThunk";
import { TagSelector } from "app/components/common/TagSelector";
/* -------------------------------------------------------------------------- */
export const DepartmentSelector = memo(
  ({ label, error, values, onChange, noEnroute = false }) => {
    const dispatch = useDispatch();
    const departments = useSelector(selDepartments);
    const options = useMemo(
      () =>
        departments
          ?.filter(
            (item) =>
              item.is_active &&
              !item.is_deleted &&
              (noEnroute ? item.airline : true)
          )
          .map((department) => ({
            id: department.id,
            value: department.name,
          })),
      [departments]
    );
    /* -------------------------------------------------------------------------- */
    useEffect(() => {
      dispatch(getDepartment());
      return () => {};
    }, []);
    /* --------------------------------- Renders -------------------------------- */
    return (
      <TagSelector
        selected={values}
        label={label}
        error={error}
        onChange={onChange}
        options={options}
        filterSelectedOptions
      />
    );
  }
);
